"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLocatorTheme;

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createLocatorTheme(_ref) {
  var primaryColor = _ref.primaryColor,
      primaryContrastText = _ref.primaryContrastText,
      secondaryColor = _ref.secondaryColor,
      secondaryContrastText = _ref.secondaryContrastText,
      headlineFontFamily = _ref.headlineFontFamily,
      bodyFontFamily = _ref.bodyFontFamily,
      overrides = _ref.overrides;
  return (0, _styles.createMuiTheme)({
    palette: {
      primary: {
        main: primaryColor,
        contrastText: primaryContrastText
      },
      secondary: {
        main: secondaryColor,
        contrastText: secondaryContrastText
      }
    },
    typography: {
      fontFamily: ['Nunito, sans-serif', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
      useNextVariants: true
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 769,
        md: 980,
        lg: 1280,
        xl: 1920
      }
    },
    overrides: _objectSpread({
      MuiMenu: {
        paper: {
          zIndex: 1400
        }
      },
      MuiDialogTitle: {
        root: {
          fontFamily: headlineFontFamily,
          color: primaryColor
        }
      },
      MuiDialogContent: {
        root: {
          fontFamily: headlineFontFamily,
          fontSize: "22px",
          fontWeight: 300,
          color: "#979a9f"
        }
      },
      MuiButton: {
        root: {
          fontFamily: headlineFontFamily
        },
        text: {
          color: "#aab4ba"
        },
        textSecondary: {
          textTransform: "none"
        },
        outlined: {
          border: "white 2px solid",
          color: "white",
          fontFamily: headlineFontFamily
        }
      },
      MuiSelect: {
        root: {
          color: primaryColor,
          fontSize: "15px",
          fontFamily: headlineFontFamily
        }
      },
      MuiFormControlLabel: {
        label: {
          fontFamily: bodyFontFamily,
          fontSize: "15px",
          color: "#979a9f",
          fontWeight: "200"
        }
      }
    }, overrides)
  });
}